import React from 'react'
//import Header from './components/header/Header'
// import Streampacks from './components/streampacks/Streampacks'
// import Comments from './components/comments/Comments'
// import Footer from './components/footer/Footer'
import Nav from './components/nav/Nav'
import Contact from './components/contact/Contact'
import Faqs from './components/faqs/Faqs'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from './components/about/About'
import Error from './pages/error/Error'
import Home from './Home'
import Store from './Store'
import Spinner from './pages/spinner/Spinner'

const App = () => {
  return (
    <BrowserRouter>
    <Routes>
      <Route path = "/" element= {<Nav />}>
      <Route index element= {<Home />}/>
      <Route path = "/about" element= {<About />}/>
      <Route path="/contact" element= {<Contact />}/>
      <Route path="/store" element= {<Store />}/>
      <Route path="/faqs" element= {<Faqs />}/>
      </Route>
      <Route path="/spinner" element= {<Spinner />}/>
      <Route path="*" element= {<Error />}/>
    </Routes>
    {/* <Header />
    <Streampacks />
    <Faqs />
    <Comments />
    <Contact />
    <Footer /> */}
    </BrowserRouter>
  )
}

export default App
